import { StoryCharacterEnum } from '../interfaces/character.interface';
import { StoryTypeEnum, WritingStyleEnum } from '../interfaces/book.interface';

export interface IOptionValue<T = string> {
  value: T;
  label: string;
}

export const StoryTypes = (): IOptionValue<StoryTypeEnum>[] => {
  return [
    {
      value: StoryTypeEnum.bedtime,
      label: 'Bedtime'
    },
    {
      value: StoryTypeEnum.fable,
      label: 'Fable'
    },
    {
      value: StoryTypeEnum.fairytale,
      label: 'Fairytale'
    },
    {
      value: StoryTypeEnum.adventure,
      label: 'Adventure'
    },
    {
      value: StoryTypeEnum.educational,
      label: 'Educational'
    },
    {
      value: StoryTypeEnum.mystery,
      label: 'Mystery'
    },
    {
      value: StoryTypeEnum.science_fiction,
      label: 'Science Fiction'
    },
    {
      value: StoryTypeEnum.realistic_fiction,
      label: 'Realistic Fiction'
    }
  ];
};

export const StoryWritingStyle = (): IOptionValue<WritingStyleEnum>[] => {
  return [
    {
      value: WritingStyleEnum.imaginative,
      label: 'Imaginative'
    },
    {
      value: WritingStyleEnum.funny,
      label: 'Funny'
    },
    {
      value: WritingStyleEnum.heartwarming,
      label: 'Heart Warming'
    },
    {
      value: WritingStyleEnum.action_packed,
      label: 'Action Packed'
    },
    {
      value: WritingStyleEnum.nostalgic,
      label: 'Nostalgic'
    },
    {
      value: WritingStyleEnum.empowering,
      label: 'Empowering'
    },
    {
      value: WritingStyleEnum.spooky,
      label: 'Spooky'
    },
    {
      value: WritingStyleEnum.educational,
      label: 'Educational'
    }
  ];
};

export const CharacterType = (): IOptionValue<StoryCharacterEnum>[] => {
  return [
    {
      value: StoryCharacterEnum.human,
      label: 'Human'
    },
    {
      value: StoryCharacterEnum.animal,
      label: 'Animal'
    },
    {
      value: StoryCharacterEnum.fictional,
      label: 'Fictional'
    }
  ];
};
